// This file has been partially auto generated. 
// Please don't make any changes to the lenses.
// Feel free to add or remove annotated properties from
// the generator data class. The corresponding lenses 
// will be removed or added on the next run of the 
// lens generator. See below for more details.
package org.solyton.solawi.bid.module.authentication.data

import org.evoleq.optics.Lensify
import org.evoleq.optics.ReadWrite
import org.evoleq.optics.lens.Lens

/**
 * Generator class.
 * Feel free to add or remove annotated properties from
 * the class. Make sure that they are annotated with
 * - @ReadOnly
 * - @ReadWrite
 * If you want that a property-lens will be generated
 * on the next run of the lens generator.
 * If not, just omit the annotation or annotate it with @Ignore.
 */
@Lensify data class User(
    @ReadWrite val username: String,
    @ReadWrite val password: String
)

/**
 * Autogenerated Lens.
 * Read and manipulate [User.username]
 */
@ReadWrite val username: Lens<User, String> by lazy{ Lens(
    get = {whole -> whole.username},
    set = {part -> {whole -> whole.copy(username = part)}}
) }
/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [User.username]
 */
@ReadWrite fun User.username(set: String.()->String ): User = copy(username = set(username)) 
/**
 * Autogenerated Lens.
 * Read and manipulate [User.password]
 */
@ReadWrite val password: Lens<User, String> by lazy{ Lens(
    get = {whole -> whole.password},
    set = {part -> {whole -> whole.copy(password = part)}}
) }
/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [User.password]
 */
@ReadWrite fun User.password(set: String.()->String ): User = copy(password = set(password)) 
